import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';
import { toPriceInEuros } from '@/helpers/prices-helper';
import { Box, Typography, useTheme } from '@mui/material';

const PriceInfo = ({ label, value, date, color, sign, isDrawer }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                fontSize: '0.85rem',
                padding: '4px 4px',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                textAlign: 'center',
                maxWidth: isDrawer ? '33.3333%' : { md: '16.666%', xs: '33.3333%' },
                width: isDrawer ? '33.3333%' : { md: '16.666%', xs: '33.3333%' },
            }}
        >
            <Box
                border={'1px solid'}
                borderColor={'border.main'}
                width={'100%'}
                p={1}
                borderRadius={1}
                height={'75px'}
                alignItems={'center'}
                justifyContent={'center'}
                display={'flex'}
                flexDirection={'column'}
                gap={0.2}
            >
                <Typography sx={{ fontSize: '0.75rem', color: theme.palette.text.primary }}>
                    {label}
                </Typography>

                <Typography
                    sx={{ display: 'flex', flexDirection: 'column' }}
                    color={value ? color : theme.palette.text.secondary}
                    fontSize={{ xs: 12, md: 14 }}
                >
                    {sign}
                    {toPriceInEuros(value?.toLocaleString())}
                </Typography>
                <Typography sx={{ fontSize: '12px', color: theme.palette.text.secondary }}>{date}</Typography>
            </Box>
        </Box>
    );
};

const JugadoresMercadoPrice = ({ player, isDrawer }) => {
    if (!player?.marketValues?.length) return null; // Evita renderizado si no hay datos
    const theme = useTheme();

    const max = player.seasonValues?.max;
    const min = player.seasonValues?.min;
    const mayorSubida = player.seasonValues?.mayorSubida;
    const mayorBajada = player.seasonValues?.mayorBajada;
    const pujaIdeal = player?.pu?.pi;
    const pujaMaxima = player?.pu?.pm;

    return (
        <CustomSectionWrapper title="Datos de mercado de la temporada" color="accent2">
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    backgroundColor: theme.palette.background.default,
                }}
            >
                <PriceInfo
                    label="Precio máximo"
                    value={max?.marketValue}
                    date={max?.created}
                    color={theme.mercado.up}
                    sign="+"
                    isDrawer={isDrawer}
                />
                <PriceInfo
                    label="Precio mínimo"
                    value={min?.marketValue}
                    date={min?.created}
                    color={theme.mercado.down}
                    sign="-"
                    isDrawer={isDrawer}
                />
                <PriceInfo
                    label="Mayor subida"
                    value={mayorSubida?.subida}
                    date={mayorSubida?.created}
                    color={theme.mercado.up}
                    sign="+"
                    isDrawer={isDrawer}
                />
                <PriceInfo
                    label="Mayor bajada"
                    value={mayorBajada?.subida}
                    date={mayorBajada?.created}
                    color={theme.mercado.down}
                    isDrawer={isDrawer}
                />
                <PriceInfo
                    label="Puja ideal"
                    value={pujaIdeal}
                    color={theme.palette.text.primary}
                    sign="+"
                    isDrawer={isDrawer}
                />
                <PriceInfo
                    label="Puja Máxima"
                    value={pujaMaxima}
                    color={theme.palette.text.primary}
                    sign="+"
                    isDrawer={isDrawer}
                />
            </Box>
        </CustomSectionWrapper>
    );
};

export default JugadoresMercadoPrice;
